const STYLE = {
    summaryBar: {
        header: { padding: '8px 0' },
        expandButton: { paddingRight: 12, margin: 0 },
        previewContainer: { overflowX: 'auto' },
    },
};

export default STYLE;
